import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Speech = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="speech icon"
    className={`shrink-0 h-${size} w-${size} ${className}`}
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.1558 35.2224H41.25C43.3286 35.2224 45 33.546 45 31.4959V5.72652C45 3.67633 43.3286 2 41.25 2H6.75C4.67141 2 3 3.67633 3 5.72652V31.4959C3 33.546 4.67141 35.2224 6.75 35.2224H14.5V45.1736L24.1558 35.2224ZM25.0019 37.2224H41.25C44.4254 37.2224 47 34.6583 47 31.4959V5.72652C47 2.56405 44.4254 0 41.25 0L6.75 0C3.57456 0 1 2.56405 1 5.72652V31.4959C1 34.6583 3.57456 37.2224 6.75 37.2224H12.5V46.5652C12.5 47.8522 14.0726 48.4864 14.9711 47.5602L25.0019 37.2224Z"
    />
  </svg>
)
